import { h, Component } from 'preact';
import { useState, useEffect } from "preact/hooks";
import CONSTANTS from '../../lib/constants';
import { route } from 'preact-router';
import Axios from 'axios';
import { getItem, setItem } from '../../lib/myStore';
import ListCard from '../../components/listCard';
import CarInsuranceLoader from '../../components/carInsuranceLoader';
import { isValidDate, formatDateTimeRelative} from '../../lib/utils';


const AllocationHistoryViewed = (props) => {
  let userInfo = getItem('userinfo');
  let [taskData, setTasksData] = useState([]);
  let [isLoading, setIsLoading] = useState(true);
  let [totalCount, setTotalCount] = useState(0);
  let [currentPageNo, setCurrentPageNo] = useState(1);
  let [searchQuery, setSearchQuery] = useState('');
  const pageSize = 10;

  const fetchTimelineData = async (pageNo, search = '') => {
    try {
      setIsLoading(true);
      let QUERY = `${CONSTANTS.API_URL}/api/v1/timeline?timelineFor=Renewal Case Allocation&pageNo=${pageNo}&pageSize=${pageSize}&sortBy=dateCreated`;
      if (search) {
        QUERY += `&displayName=${encodeURIComponent(search)}`;
      }
      let taskResponseAll = await Axios.get(QUERY);
      await setTasksData(taskResponseAll.data.data);
      setTotalCount(taskResponseAll.data.totalCount);
      setCurrentPageNo(pageNo);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching timeline data:', error);
      setIsLoading(false);
    }
  };

  useEffect(async() => {
    if (props.isVisible) {
      fetchTimelineData(1);
    }
  },[props]);

  const handleNextPage = () => {
    const totalPages = Math.ceil(totalCount / pageSize);
    if (currentPageNo < totalPages) {
      fetchTimelineData(currentPageNo + 1, searchQuery);
    }
  };

  const handlePrevPage = () => {
    if (currentPageNo > 1) {
      fetchTimelineData(currentPageNo - 1, searchQuery);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearch = () => {
    fetchTimelineData(1, searchQuery);
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    fetchTimelineData(1, '');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const totalPages = Math.ceil(totalCount / pageSize);

  const highlightText = (text, query) => {
    if (!query) return text;
    
    const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, index) => {
      if (part.toLowerCase() === query.toLowerCase()) {
        return <span key={index} style={{ backgroundColor: '#ffeb3b', fontWeight: 'bold', padding: '2px 4px', borderRadius: '2px' }}>{part}</span>;
      }
      return part;
    });
  };

  async function getRowsListForTask(data) {
    const colList = [{
      label: 'Name',
      field: 'displayName',
      width: '200px',
      sort: 'asc'
    },
    {
      label: 'Active Since',
      field: 'createdOn',
      sort: 'asc'
    }, {
      label: 'Deadline',
      field: 'deadline',
      sort: 'asc'
    }, {
      label: 'Case ID',
      field: 'caseID',
      sort: 'desc'
    }];
    const listObj = {
      columns: colList, rows: data
    };
    return listObj;
  }

  return (
    <div style="width:100%; background:#fff; height: 100vh">
      <div class="modal-header" style='border-radius: 0 !important'>
        <span class="fs-12">
          <div class="display-flex">
            <ul class="breadrcrumb_arrows_inverted m-r-8">
              <li>{props.title}</li>
            </ul>
          </div>
        </span>
      </div>
      <div class="search-pagination-controls" style="display: flex; justify-content: space-between; align-items: center; padding: 10px; gap: 15px; background: #f5f5f5; border-bottom: 1px solid #ddd;">
        <div style="display: flex; align-items: center; gap: 10px; flex: 1;">
          <input 
            type="text" 
            placeholder="Search by Customer name..."
            value={searchQuery}
            onChange={handleSearchChange}
            onKeyPress={handleKeyPress}
            style={{
              padding: '8px 12px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '13px',
              width: '250px',
              outline: 'none'
            }}
          />
          <button 
            onClick={handleSearch}
            style={{
              padding: '8px 10px',
              border: '1px solid #ccc',
              background: '#fff',
              cursor: 'pointer',
              borderRadius: '4px',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '30px',
              height: '30px',
              title: 'Search'
            }}
            title="Search"
          >
            🔍
          </button>
          {searchQuery && (
            <button 
              onClick={handleClearSearch}
              style={{
                padding: '8px 10px',
                border: '1px solid #ccc',
                background: '#fff',
                cursor: 'pointer',
                borderRadius: '4px',
                fontSize: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '30px',
                height: '30px',
                title: 'Clear'
              }}
              title="Clear"
            >
              ✕
            </button>
          )}
        </div>
        <div style="display: flex; align-items: center; gap: 10px;">
          <button 
            onClick={handlePrevPage}
            disabled={currentPageNo === 1}
            style={{
              padding: '8px 12px',
              border: '1px solid #ccc',
              background: currentPageNo === 1 ? '#e0e0e0' : '#fff',
              cursor: currentPageNo === 1 ? 'not-allowed' : 'pointer',
              borderRadius: '4px',
              fontSize: '14px',
              fontWeight: 'bold',
              color: currentPageNo === 1 ? '#999' : '#333'
            }}
          >
            &lt; Prev
          </button>
          <span style="font-size: 13px; font-weight: 500; minWidth: '180px'; textAlign: 'center';">
            Page {currentPageNo} of {totalPages} (Total: {totalCount})
          </span>
          <button 
            onClick={handleNextPage}
            disabled={currentPageNo >= totalPages}
            style={{
              padding: '8px 12px',
              border: '1px solid #ccc',
              background: currentPageNo >= totalPages ? '#e0e0e0' : '#fff',
              cursor: currentPageNo >= totalPages ? 'not-allowed' : 'pointer',
              borderRadius: '4px',
              fontSize: '14px',
              fontWeight: 'bold',
              color: currentPageNo >= totalPages ? '#999' : '#333'
            }}
          >
            Next &gt;
          </button>
        </div>
      </div>
      {
        isLoading ?
          <CarInsuranceLoader top='25%' left='25%' />
          :
          <div style='height: 85vh; overflow-y: auto; overflow-x: hidden;'>
            <div class="p-l-0 p-r-0  listcard-thead">
              <div class="pos-sticky row flex-nowrap listcard-tr">
                <span title="Task" class="  p-t-8   listcard-th" style="width: 40px;">
                  <span class="pos-relative"> Sr.
                  </span>
                </span>
                <span title="Assignee" class="  p-t-8   listcard-th" style="width: 250px; text-align: left">
                  <span class="pos-relative"> Assigned By / Assignee
                  </span>
                </span>
                <span title="Assigned To" class="  p-t-8 listcard-th " style="width: 110px">
                  <span class="pos-relative"> Assigned @</span>
                </span>
                <span title="Count" class="  p-t-8 listcard-th " style="width: 100px">
                  <span class="pos-relative"> Count</span>
                </span>
                <span title="Interactions" class="  p-t-8 listcard-th " style="width: 500PX; text-align: left">
                  <span class="pos-relative"> Customers Name</span>
                </span>
              </div>
            </div>
            {
              taskData.length > 0 && taskData.map ((row, index) => (
                <div class={`listCard listCard-border-bottom pos-relative text-black mobile-m-r-4 `}>
                  <div class='msgContainer  mobile-listcard-border cursor-pointer animatedHover'>
                    <div class='display-flex justify-between align-center'>
                      <div class="display-flex align-center">
                        <span style="width: 40px;border-right: 1px solid rgba(0,0,0,0.051);" class=" p-l-10 fs-10 fadeMoveUpAnimationNotForwards flex-c-m  listcard-td  ">
                          <span class="w-fit-content cursor-default" >
                            {(currentPageNo - 1) * pageSize + index + 1}.
                          </span>
                        </span>
                        <span style="width: 250px; text-align: left;" class={`fadeMoveUpAnimationNotForwards pos-relative p-0 listcard-td `} >
                          {/*
                          Bug: COMP_BG_672 Alignment for Last Viewed At dates are not correct
                          Modification: change width full to 250px
                          By: Masum Raja
                          Date: 19/09/2023
                        */}
                          <div class="h-full w-250px p-l-10 display-flex flex-direction-row flex-l-m  cursor-pointer">
                            <div class="" >
                              <span class=" h-full w-full">
                                <p class="h-full justify-center flex-direction-column p-0">
                                  {<span title="Info" class="p-0 listcard1-case accordion-category-heading fs-10 first-letter-capital" style="color: tomato; ">{row.createdByName}
                                  </span>}
                                  <span class="h-full flex-l-m fs-12" title={row.changeValue}>{row.changeValue}
                                  </span>
                                </p>
                              </span>
                            </div>
                          </div>
                        </span>
                        <span style="width: 110px;" class=" fadeMoveUpAnimationNotForwards flex-c-m  listcard-td  ">
                          <span class="w-fit-content cursor-default fs-11" style="">
                            {isValidDate(row.createdAt) ? formatDateTimeRelative(row.createdAt) : row.createdAt}
                          </span>
                        </span>
                        <span style="width: 100px;" class=" fadeMoveUpAnimationNotForwards flex-c-m  listcard-td  ">
                          <span class="w-fit-content cursor-default fs-11" style="">
                            {row.objectCount ? row.objectCount : row.objectCount}
                          </span>
                        </span>
                        <span class=" fadeMoveUpAnimationNotForwards listcard-td  " style='margin-bottom: 10px; width: 500px'>
                          <span class="w-fit-content cursor-default fs-11">
                            {
                              row.objectIDs && row.objectIDs.map ((obj) => (
                                <span onClick={(e) => {
                                  props.toggleCaseAllocationHistoryModal();
                                  route(`/processView/${obj.uuid}`);
                                }} class='cursor-pointer' style="margin: 5px; padding: 5px 10px; background: #eff0f3; border-radius: 5px; display: inline-block;" title={obj.displayName}>{highlightText(obj.displayName, searchQuery)}</span>
                              ))
                            }

                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            }
            {
              taskData.length === 0 && (
                <div style="display: flex; justify-content: center; align-items: center; height: 200px; width: 100%;">
                  <span style="font-size: 16px; color: #999; fontWeight: 500;">No records found</span>
                </div>
              )
            }
              </div>
            
      }
    </div>
    
  );
};

export default AllocationHistoryViewed;
